import './wia-prospect-popup.html';
import WiaProspectPopup from './wia-prospect-popup.js';

export default WiaProspectPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/wia-prospect-popup/index.js